import React from 'react';
import useNavigateTo from '../features/NavigateTo/useNavigateTo';
export default function NavigateToProvider() {
    useNavigateTo();
    return React.createElement(React.Fragment, null);
}
